import { render, staticRenderFns } from "./App.vue?vue&type=template&id=533c0cac&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=533c0cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.6_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c0cac",
  null
  
)

export default component.exports